import { render, staticRenderFns } from "./ItemCard.vue?vue&type=template&id=4cc7af73"
import script from "./ItemCard.vue?vue&type=script&lang=ts"
export * from "./ItemCard.vue?vue&type=script&lang=ts"
import style0 from "./ItemCard.vue?vue&type=style&index=0&id=4cc7af73&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\ldemenego\\REPOS\\VUEJS\\configuratore-demenego-v2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cc7af73')) {
      api.createRecord('4cc7af73', component.options)
    } else {
      api.reload('4cc7af73', component.options)
    }
    module.hot.accept("./ItemCard.vue?vue&type=template&id=4cc7af73", function () {
      api.rerender('4cc7af73', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ItemCard.vue"
export default component.exports